import { render } from "./DhlGeoWidget.vue?vue&type=template&id=a4957962&scoped=true"
import script from "./DhlGeoWidget.vue?vue&type=script&lang=js"
export * from "./DhlGeoWidget.vue?vue&type=script&lang=js"

import "./DhlGeoWidget.vue?vue&type=style&index=0&id=a4957962&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4957962"]])

export default __exports__